export default __webpack_public_path__ + "assets/fonts/2f5deac8888dbc4ec398d644f82238ac.woff2";